import { useMutation, useQueryClient } from '@tanstack/react-query';
import { axios } from '@/lib/axios/axios';
import { MESSAGING_API_BASE, messagingQueryKeys } from '../config';
import { SendMessageBody, MessageResponse } from '../types/backend';
import { updateChannelLastMessageAt } from '../utils/updateChannelCache';

export type SendMessageDTO = {
  channelId: number;
  content?: string;
  replyToMessageId?: number;
  storedFileIds?: number[];
};

const sendMessage = async (data: SendMessageDTO): Promise<MessageResponse> => {
  const { channelId, content, replyToMessageId, storedFileIds } = data;

  const body: SendMessageBody = {
    content,
    'reply-to-message-id': replyToMessageId,
    'stored-file-ids': storedFileIds,
  };

  return axios.post(
    `${MESSAGING_API_BASE}/channels/${channelId}/messages`,
    body
  );
};

export const useSendMessage = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: SendMessageDTO) => sendMessage(data),
    onSuccess: (newMessage) => {
      // Socket will handle adding the message in real-time via handleNewMessage
      // We just need to update channel metadata

      // Update channel list cache directly (updates last-message-at timestamp)
      updateChannelLastMessageAt(
        queryClient,
        newMessage['channel-id'],
        newMessage['date-added']
      );

      // Invalidate unread counts
      queryClient.invalidateQueries(messagingQueryKeys.unreadCounts());
    },
  });
};
